import React, {Component} from 'react';
import Draggable, {DraggableCore} from 'react-draggable';
import {Row, Col, Collapse, Alert} from 'antd';
import DeviceAINMini from './DeviceAINMini'
import DeviceDINMini from './DeviceDINMini'
import DeviceRelay from './DeviceRelay'
import IconTemperature from '../style/icon/IconTemperature'
import IconHumidity from '../style/icon/IconHumidity'
import IconDoorOpened from '../style/icon/IconDoorOpened'
import IconDoorClosed from '../style/icon/IconDoorClosed'
import IconMotion from '../style/icon/IconMotion'
import IconSmoke from '../style/icon/IconSmoke'
import IconLamp from '../style/icon/IconLamp'
import IconLampChandelier from '../style/icon/IconLampChandelier'
import IconLampCeilling from '../style/icon/IconLampCeilling'
import IconLampCompact from '../style/icon/IconLampCompact'
import IconLampSleep from '../style/icon/IconLampSleep'
import IconHeater from '../style/icon/IconHeater'
import IconPump from '../style/icon/IconPump'
import IconACMeter from '../style/icon/IconACMeter'
import IconPowerDayMeter from '../style/icon/IconPowerDayMeter'
import IconPowerMonthMeter from '../style/icon/IconPowerMonthMeter'
import img from '../style/imgs/layout.jpg';

import {
  SUB_CATEGORY_TEMPERATURE,
  SUB_CATEGORY_HUMIDITY,
  SUB_CATEGORY_V_AC_METER,
  SUB_CATEGORY_SMOKE,
  SUB_CATEGORY_DOOR,
  SUB_CATEGORY_MOTION,
  //SUB_CATEGORY_GLASS,
  //SUB_CATEGORY_GAS,
  //SUB_CATEGORY_HEAT_EXCEED,
  //SUB_CATEGORY_BUTTON,
  SUB_CATEGORY_LAMP,
  SUB_CATEGORY_LAMP_COMPACT,
  SUB_CATEGORY_LAMP_SLEEP,
  SUB_CATEGORY_LAMP_TABLE,
  SUB_CATEGORY_LAMP_CEILLING,
  SUB_CATEGORY_LAMP_DECOR,
  SUB_CATEGORY_LAMP_CHANDELIER,
  SUB_CATEGORY_FAN_1,
  SUB_CATEGORY_FAN_2,
  SUB_CATEGORY_FAN_CEILLING,
  SUB_CATEGORY_OUTLET,
  SUB_CATEGORY_WATERING,
  SUB_CATEGORY_HEATER,
  SUB_CATEGORY_BELL,
  SUB_CATEGORY_ALARM_BELL,
  SUB_CATEGORY_DO_NOT_DISTURB,
  //SUB_CATEGORY_CURTAIN,
  //SUB_CATEGORY_AIR_CONTROLLER,
  SUB_CATEGORY_PUMP,
  SUB_CATEGORY_DOOR_IN_HOUSE,
  SUB_CATEGORY_TEMPERATURE_OUTSIDE,
  SUB_CATEGORY_HUMIDITY_OUTSIDE,
  SUB_CATEGORY_POWER_METER,
  SUB_CATEGORY_POWER_METER_DAY,
  SUB_CATEGORY_POWER_METER_MONTH,
  DEVICE_STATUS_STATE_ON,
  //DEVICE_STATUS_STATE_OFF,
  DEVICE_STATUS_STATE_LOW,
  //DEVICE_STATUS_STATE_NORMAL,
  DEVICE_STATUS_STATE_HIGH,
  DEVICE_STATUS_COLOR_ON,
  DEVICE_STATUS_COLOR_OFF,
  DEVICE_STATUS_COLOR_TOO_LOW,
  DEVICE_STATUS_COLOR_LOW,
  DEVICE_STATUS_COLOR_NORMAL,
  DEVICE_STATUS_COLOR_HIGH,
  DEVICE_STATUS_COLOR_TOO_HIGH,
  DEVICE_STATUS_AIN_STATE_TOO_LOW,
  DEVICE_STATUS_AIN_STATE_LOW,
  DEVICE_STATUS_AIN_STATE_NORMAL,
  DEVICE_STATUS_AIN_STATE_HIGH,
  DEVICE_STATUS_AIN_STATE_TOO_HIGH,
  //DEVICE_STATUS_METER_STATE_NORMAL,
  DEVICE_STATUS_METER_STATE_HIGH
} from '../constants/defaultValues'
const PanelCollapse = Collapse.Panel;

class StationCardDeviceLayout extends Component {
  state = {
    activeDrags: 0
  }
  handleClick(dev) {
    this.props.onClick(dev)
  }

  displayDevice(dev) {
    let color = DEVICE_STATUS_COLOR_OFF
    switch (dev.SubCategory) {
      case SUB_CATEGORY_TEMPERATURE:
      case SUB_CATEGORY_TEMPERATURE_OUTSIDE:
        color = DEVICE_STATUS_COLOR_NORMAL
        if (dev.State === DEVICE_STATUS_AIN_STATE_TOO_LOW) {
          color = DEVICE_STATUS_COLOR_TOO_LOW
        }
        if (dev.State === DEVICE_STATUS_AIN_STATE_LOW) {
          color = DEVICE_STATUS_COLOR_LOW
        }
        if (dev.State === DEVICE_STATUS_AIN_STATE_NORMAL) {
          color = DEVICE_STATUS_COLOR_NORMAL
        }
        if (dev.State === DEVICE_STATUS_AIN_STATE_HIGH) {
          color = DEVICE_STATUS_COLOR_HIGH
        }
        if (dev.State === DEVICE_STATUS_AIN_STATE_TOO_HIGH) {
          color = DEVICE_STATUS_COLOR_TOO_HIGH
        }
        return <DeviceAINMini icon={<IconTemperature color = {
            color
          } />} device={dev} unit="°C" color={color}/>
      case SUB_CATEGORY_HUMIDITY:
      case SUB_CATEGORY_HUMIDITY_OUTSIDE:
        color = DEVICE_STATUS_COLOR_NORMAL
        if (dev.State === DEVICE_STATUS_STATE_LOW) {
          color = DEVICE_STATUS_COLOR_LOW
        } else {
          if (dev.State === DEVICE_STATUS_STATE_HIGH) {
            color = DEVICE_STATUS_COLOR_HIGH
          }
        }
        return <DeviceAINMini icon={<IconHumidity color = {
            color
          } />} device={dev} unit="%" color={color}/>
      case SUB_CATEGORY_V_AC_METER:
        color = DEVICE_STATUS_COLOR_NORMAL
        if (dev.State === DEVICE_STATUS_STATE_LOW) {
          color = DEVICE_STATUS_COLOR_LOW
        } else if (dev.State === DEVICE_STATUS_STATE_HIGH) {
          color = DEVICE_STATUS_COLOR_HIGH
        }
        return <DeviceAINMini icon={<IconACMeter color = {
            color
          } />} unit="V" color={color} device={dev}/>
      case SUB_CATEGORY_POWER_METER:
        color = DEVICE_STATUS_COLOR_NORMAL
        if (dev.State === DEVICE_STATUS_METER_STATE_HIGH) {
          color = DEVICE_STATUS_COLOR_HIGH
        }
        return <DeviceAINMini icon={<IconACMeter color = {
            color
          } />} unit="watt" color={color} device={dev}/>
      case SUB_CATEGORY_POWER_METER_DAY:
        color = DEVICE_STATUS_COLOR_NORMAL
        if (dev.State === DEVICE_STATUS_METER_STATE_HIGH) {
          color = DEVICE_STATUS_COLOR_HIGH
        }
        return <DeviceAINMini icon={<IconPowerDayMeter color = {
            color
          } />} unit="kwh" color={color} device={dev}/>
      case SUB_CATEGORY_POWER_METER_MONTH:
        color = DEVICE_STATUS_COLOR_NORMAL
        if (dev.State === DEVICE_STATUS_METER_STATE_HIGH) {
          color = DEVICE_STATUS_COLOR_HIGH
        }
        return <DeviceAINMini icon={<IconPowerMonthMeter color = {
            color
          } />} unit="kwh" color={color} device={dev}/>
      case SUB_CATEGORY_SMOKE:
        return <DeviceDINMini icon={<IconSmoke color = "#ff9421" />} device={dev}/>
      case SUB_CATEGORY_DOOR:
      case SUB_CATEGORY_DOOR_IN_HOUSE:
        if (dev.State === DEVICE_STATUS_STATE_ON) {
          color = DEVICE_STATUS_COLOR_HIGH
          return <DeviceDINMini icon={<IconDoorOpened color = {
              color
            } />} device={dev} color={color}/>
        } else {
          color = DEVICE_STATUS_COLOR_NORMAL
          return <DeviceDINMini icon={<IconDoorClosed color = {
              color
            } />} device={dev} color={color}/>
        }
      case SUB_CATEGORY_MOTION:
        if (dev.State === DEVICE_STATUS_STATE_ON) {
          color = DEVICE_STATUS_COLOR_HIGH
        } else {
          color = DEVICE_STATUS_COLOR_NORMAL
        }
        return <DeviceDINMini icon={<IconMotion color = {
            color
          } />} device={dev} color={color}/>
      case SUB_CATEGORY_LAMP:
      case SUB_CATEGORY_LAMP_DECOR:
      case SUB_CATEGORY_LAMP_TABLE:
      case SUB_CATEGORY_FAN_1:
      case SUB_CATEGORY_FAN_2:
      case SUB_CATEGORY_FAN_CEILLING:
      case SUB_CATEGORY_OUTLET:
      case SUB_CATEGORY_WATERING:
      case SUB_CATEGORY_BELL:
      case SUB_CATEGORY_ALARM_BELL:
      case SUB_CATEGORY_DO_NOT_DISTURB:
        if (dev.State === DEVICE_STATUS_STATE_ON) {
          color = DEVICE_STATUS_COLOR_ON
        }
        return <DeviceRelay icon={<IconLamp color = {
            color
          } />} device={dev} color={color} onClick={(dev) => this.handleClick(dev)}/>
      case SUB_CATEGORY_LAMP_CHANDELIER:
        if (dev.State === DEVICE_STATUS_STATE_ON) {
          color = DEVICE_STATUS_COLOR_ON
        }
        return <DeviceRelay icon={<IconLampChandelier color = {
            color
          } />} device={dev} color={color} onClick={(dev) => this.handleClick(dev)}/>
      case SUB_CATEGORY_LAMP_COMPACT:
        if (dev.State === DEVICE_STATUS_STATE_ON) {
          color = DEVICE_STATUS_COLOR_ON
        }
        return <DeviceRelay icon={<IconLampCompact color = {
            color
          } />} device={dev} color={color} onClick={(dev) => this.handleClick(dev)}/>
      case SUB_CATEGORY_LAMP_SLEEP:
        if (dev.State === DEVICE_STATUS_STATE_ON) {
          color = DEVICE_STATUS_COLOR_ON
        }
        return <DeviceRelay icon={<IconLampSleep color = {
            color
          } />} device={dev} color={color} onClick={(dev) => this.handleClick(dev)}/>
      case SUB_CATEGORY_LAMP_CEILLING:
        if (dev.State === DEVICE_STATUS_STATE_ON) {
          color = DEVICE_STATUS_COLOR_ON
        }
        return <DeviceRelay icon={<IconLampCeilling color = {
            color
          } />} device={dev} color={color} onClick={(dev) => this.handleClick(dev)}/>
      case SUB_CATEGORY_HEATER:
        if (dev.State === DEVICE_STATUS_STATE_ON) {
          color = DEVICE_STATUS_COLOR_ON
        }
        return <DeviceRelay icon={<IconHeater color = {
            color
          } />} device={dev} color={color} onClick={(dev) => this.handleClick(dev)}/>
      case SUB_CATEGORY_PUMP:
        if (dev.State === DEVICE_STATUS_STATE_ON) {
          color = DEVICE_STATUS_COLOR_ON
        }
        return <DeviceRelay icon={<IconPump color = {
            color
          } />} device={dev} color={color} onClick={(dev) => this.handleClick(dev)}/>
      default:
        return <span>{dev.Name}</span>
    }
  }

  onStart = () => {
    this.setState({
      activeDrags: ++this.state.activeDrags
    });
  }

  onStop = () => {
    this.setState({
      activeDrags: --this.state.activeDrags
    });
  }

  render() {
    const rooms = this.props.rooms || []
    const devices = this.props.devices || []

    return <div style={{
        backgroundImage: `url("${img}")`,
        height: '100%'
      }}>
      {
        !this.props.error
          ? <Row align="middle" style={{
                height: '100%'
              }}>
              <div className="device-list">
                {
                  devices.map((dev, i) => {
                    const elementDev = this.displayDevice(dev)
                    return <Draggable onStart={this.onStart} onStop={this.onStop} key={i + 1}>
                      <Col xs={{
                          span: 12
                        }} sm={{
                          span: 8
                        }} md={{
                          span: 8
                        }} lg={{
                          span: 8
                        }} xl={{
                          span: 2
                        }} key={dev.DeviceId}>

                          {elementDev}

                      </Col>
                    </Draggable>
                  })
                }
              </div>
            </Row>
          : <Alert message="Error" description="Lỗi dữ liệu!" type="error"/>
      }
    </div>
  }
}

export default StationCardDeviceLayout;



// WEBPACK FOOTER //
// ./src/components/StationCardDeviceLayout.js